<template>
  <div />
</template>

<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useRoute } from 'vue-router'

  const route = useRoute()

  onMounted(() => {
    const reactHost = (import.meta.env as { VUE_CHAT_HOST?: string }).VUE_CHAT_HOST
    const isProxyEntry = window.location.port === '8005'
    // React routes live at the domain root; /react is only the build assets directory.
    const targetOrigin = !reactHost || isProxyEntry ? window.location.origin : new URL(reactHost).origin
    const absoluteTarget = new URL(route.fullPath, targetOrigin).toString()

    window.location.assign(absoluteTarget)
  })
</script>
